module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",
    class: _vm.triggerButtonClass,
    attrs: {
      "title": _vm.stage.title,
      "data-placement": "top",
      "data-toggle": "dropdown",
      "type": "button",
      "id": "stageDropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.onClickStage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "aria-label": _vm.stage.title
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svgIcon)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",
    attrs: {
      "aria-labelledby": "stageDropdown"
    }
  }, [_c('li', {
    staticClass: "js-builds-dropdown-list scrollable-menu",
    class: _vm.dropdownClass
  }, [(_vm.isLoading) ? _c('loading-icon') : _c('ul', {
    domProps: {
      "innerHTML": _vm._s(_vm.dropdownContent)
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0b4b1a"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3f0b4b1a"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
// module chunks = commit_pipelines pipelines vue_merge_request_widget